import { mountComments } from '../../../../js2/apps/blogs/miniapps';

export function initStatic(conf) {
    const node = conf.node;
    // we must be sure that we do not double-register at the node

    const at = (text) => node.getAttribute('data-comment2-' + text);

    const placeholder = document.getElementById(at('placeholder-id'));

    if (!at('no-comments')) {
        const key = at('ids').replace(',', '/');
        mountComments(placeholder, key, node);
    }
}
